app.navBar = {
    settings: {
        $el: $('#nav-bar, #off-canvas-nav-bar'),
        $trigger: $('#nav-bar-trigger'),
        navBarOffsetTop: null,
        navBarHeight: null,
        lastWindowScrollTop: 0,
        hideOnScroll: false,
        fixedClass: 'nav-bar--fixed',
        showClass: 'nav-bar--show',
        mobileShowClass: 'nav-bar--mobile-show',
        transformClass: 'nav-bar--transform',
        allwaysShowOnMobile: true,
        allwaysShowOnMobileClass: 'nav-bar--always-show-on-mobile'
    },

    init: function(_scrollTop){
        if (app.navBar.settings.$el.length > 0) {

            if (app.navBar.settings.$el.attr('id') === 'off-canvas-nav-bar') {
                app.navBar.settings.fixedClass =  'off-canvas-' + app.navBar.settings.fixedClass;
                app.navBar.settings.showClass = 'off-canvas-' + app.navBar.settings.showClass;
                app.navBar.settings.mobileShowClass = 'off-canvas-' + app.navBar.settings.mobileShowClass;
                app.navBar.settings.transformClass = 'off-canvas-' + app.navBar.settings.transformClass;
            }

            app.navBar.settings.navBarOffsetTop = app.navBar.settings.$el.offset().top,
            app.navBar.settings.navBarHeight = app.navBar.settings.$el.height();

            app.navBar.addClasses();
            app.navBar.trigger();
            app.navBar.mobileClick();
            app.navBar.mobileLinks();
        }
    },

    /**
     * Add mobile links for the hamburger menu.
     * These links get taken from the top level menu
     * and get inserted at the end of the main menu list.
     */
    mobileLinks: function () {
        var $list = $('.nav-bar__list');

        $('.nav-bar-extra__item').each(function () {
            var $clone = $(this).clone(),
                $readspeaker = $clone.find('#toggleReadSpeaker');

            $clone.find('a').attr('class', 'nav-bar__link');
            $readspeaker.length > 0 ? $clone.attr('class', 'nav-bar__item display-none') : $clone.attr('class', 'nav-bar__item hide-beta-and-up');
            $list.append($clone[0].outerHTML);
        });
    },

    resizer: function () {
        app.settings.$container.css({'padding-top': app.navBar.settings.$el.height()});
    },

    addClasses: function () {
        app.settings.$container.css({'padding-top': app.navBar.settings.$el.height()});
    },

    mobileClick: function() {
        app.settings.$html.on('click', '.menu-bar__item--dropdown .menu-bar__link', function (event) {
            if ( ! Modernizr.mq(app.mediaQueries.epsilonAndUp)) {
                var $dropdown = $(this).closest('.menu-bar__item--dropdown');

                event.preventDefault();
                $('.menu-bar__item--dropdown-open').not($dropdown).removeClass('menu-bar__item--dropdown-open').find('.menu-bar__sub').slideDown();
                $dropdown.toggleClass('menu-bar__item--dropdown-open').find('.menu-bar__sub').slideToggle();
            }
        });
    },

    trigger: function () {
        app.navBar.settings.$trigger.on('click', function (event) {
            event.preventDefault();

            app.navBar.settings.$el.toggleClass(app.navBar.settings.mobileShowClass);
        });
    }
};